import { render, staticRenderFns } from "./LiveStreamPlayer.vue?vue&type=template&id=0ace3f06&scoped=true&"
import script from "./LiveStreamPlayer.vue?vue&type=script&lang=js&"
export * from "./LiveStreamPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace3f06",
  null
  
)

export default component.exports